<template>	
<div class="row m-0 p-0 mb-1">
	<div class="row col-xl p-0 m-0 g-1">
		<div class="col-md-6">
			<half-line-vidget 
				name="Час опитування"
				:value="station === undefined ? undefined : station.updateTimeText"
				:activityLabel="true"
				@dblclick="showPerformStationSurveyForm = true"
			/>
		</div>
		<div class="col-md-6">
			<half-line-vidget 
				name="Час вимірювання"
				:value="station === undefined ? undefined : station.measureTimeText"
			/>
		</div>
		<div class="col-md-6">
			<half-line-vidget 
				name="Режим стабілізації"
				:icon="station.breaker.getMetricValue(station.breaker.metricKeys.fBreakerActive) ? 'breaker' : undefined"
				:value="station === undefined ? undefined : stabilizationModePromt"
				:activityLabel="true"
				:style="station.power_unit.isConnect ? '' : 'filter: grayscale(100%);'"
				@dblclick="showSetStabilizationForm = true"
			/>
		</div>
		<div class="col-md-6">
			<half-line-vidget 
				name="Силовий модуль"
				:value="station === undefined ? undefined : station.power_unit.stateText"
				:activityLabel="true"
				:style="station.power_unit.isConnect ? '' : 'filter: grayscale(100%);'"
				@dblclick="showStartStopForm = true"
			/>
		</div>
	</div>
	<div class="row col-xl p-0 m-0 g-1">
		<div class="col-12 d-none d-xl-block">
			<half-line-vidget
				name="&nbsp;"
				value="&nbsp;"
			/>
		</div>
		<div class="col-12">
			<half-line-vidget
				name="Остання блискавка"
				:value="station.passport.has(Station.passportKeys.location)
					? (lastLightningEvent ?
						// `${dateTimeToString(
						// 	lastLightningEvent[eventSchema.payload.key][eventSchema.payload.allowed.flashTimeUTC.key]
						// )}, ${lastLightningEvent[eventSchema.payload.key][eventSchema.payload.allowed.distanceKm.key].toFixed(1)} км`
						`${dateTimeToString(
							lastLightningEvent[eventSchema.payload.key][eventSchema.payload.allowed.flashTimeUTC.key]
						)}, ${
							isLightningAboveStaion(lastLightningEvent[eventSchema.payload.key])
								? 'над станцією'
								: `${flashDistance(lastLightningEvent[eventSchema.payload.key])?.toFixed(2)} км`
						}`
						: 'не виявлено'
					) : 'Вкажіть координати станції'
				"
				:activityLabel="lastLightningEvent"
				:style="station.passport.has(Station.passportKeys.location) ? '' : 'filter: grayscale(100%);'"
				@dblclick="showLightningsTable = true"
			/>
		</div>
	</div>
</div>

<div class="row m-0 p-0 mt-1">
	<div class="row col-xxl p-0 m-0 mb-lg-1 g-1">
		<div class="col-md-6 col-lg-3 m-0 mb-1 mb-lg-0">
			<!-- Output current -->
			<div class="half-transparent-border widget-7x5">
				<iout-chart
					:value="station.getFormatedMetric(PowerUnit.metricKeys.iOut, 'power')"
					:style="station.power_unit.isConnect ? '' : 'filter: grayscale(100%);'"
				/>
			</div>
		</div>
		<div class="col-md-6 col-lg-3 m-0 mb-1 mb-lg-0">
			<!-- Output voltage -->
			<div class="half-transparent-border widget-7x5">
				<uout-chart
					:value="station.getFormatedMetric(PowerUnit.metricKeys.uOut, 'power')"
					:style="station.power_unit.isConnect ? '' : 'filter: grayscale(100%);'"
				/>
			</div>
		</div>
		<div class="col-md-6 col-lg-3 m-0 mb-1 mb-lg-0">
			<!-- U protect sum chart -->
			<div class="half-transparent-border widget-7x5">
				<uprotect-chart
					:value="uProtect"
					:style="
						station.uProtectSource == 'power' ? 
							station.power_unit.isConnect ? '' : 'filter: grayscale(100%);' :
							station.uProtectSource == 'service' ? 
								station.service_unit.isConnect ? '' : 'filter: grayscale(100%);' :
									'filter: grayscale(100%);'
					"
				/>
			</div>
		</div>
		<div class="col-md-6 col-lg-3 m-0 mb-1 mb-lg-0">
			<tile-vidget
				title="Захисний потенціал, 10&nbsp;хв"
				class="h-100 w-100 m-0 px-1"
				:style="station.service_unit.isConnect ? '' : 'filter: grayscale(100%);'"
				style="margin: 0 !important;"
			>
				<div class="row m-0 mt-3 p-0">
					<div class="col-6 mx-0 ps-2 text-start metric-name-text">Emin</div>
					<div class="col-6 mx-0 pe-2 text-end metric-value-text">
						{{ station.getFormatedMetric('Uprotect_min', 'service', 2) }}
					</div>
				</div>
				<div class="row m-0 p-0 my-2">
					<div class="col-6 mx-0 ps-2 text-start metric-name-text">Emax</div>
					<div class="col-6 mx-0 pe-2 text-end metric-value-text">
						{{ station.getFormatedMetric('Uprotect_max', 'service', 2) }}
					</div>
				</div>
				<div class="row m-0 p-0">
					<div class="col-6 mx-0 ps-2 text-start metric-name-text">Eavg</div>
					<div class="col-6 mx-0 pe-2 text-end metric-value-text">
						{{ station.getFormatedMetric('Uprotect_avg', 'service', 2) }}
					</div>
				</div>
			</tile-vidget>
		</div>
	</div>
	<div class="row col-xxl p-0 m-0 g-1">
		<div class="col-12 m-0 mb-1 mb-xxl-0">
			<half-line-vidget
				name="Обрив кабелю анодного заземлювача"
				:value="stationMetricFlagText(PowerUnit.metricKeys.fBreakCurrent)"
				:style="station.power_unit.isConnect ? '' : 'filter: grayscale(100%);'"
			/>
		</div>
		<div class="col-12 m-0 mb-1 mb-xxl-0">
			<half-line-vidget
				name="Відкриття корпусу СКЗ"
				:value="boxDoorStatePromt"
				:style="station.service_unit.isConnect ? '' : 'filter: grayscale(100%);'"
			/>
		</div>
		<div class="col-12 m-0 mb-1 mb-xxl-0">
			<half-line-vidget
				name="Обрив мережі живлення"
				:value="stationMetricFlagText(ServiceUnit.metricKeys.fExternalPwr, true)"
				:style="station.service_unit.isConnect ? '' : 'filter: grayscale(100%);'"
			/>
		</div>
		<div class="col-12 m-0 mb-1 mb-xxl-0">
			<half-line-vidget
				name="Обрив МСЕП"
				:value="stationMetricFlagText(PowerUnit.metricKeys.fBreakPotential)"
				:style="station.power_unit.isConnect ? '' : 'filter: grayscale(100%);'"
			/>
		</div>
		<div class="col-12 m-0 mb-0 mb-xxl-0">
			<half-line-vidget
				name="Покази лічильника енергії"
				:value="electricMeterValue[0]"
				:unit="electricMeterValue[1]"
				:activityLabel="station?.electricMeterIsSeparateUnit"
				@dblclick="showPerformElectricMeterSurveyForm = station?.electricMeterIsSeparateUnit"
				:style="electricMeterConnection ? '' : 'filter: grayscale(100%);'"
			/>
		</div>
	</div>
</div>

<div class="row m-0 p-0 mt-1 mt-xxl-0">
	<div class="row col-xxl p-0 m-0 mb-lg-1 g-1">
		<div class="col-md-6 col-lg-3 m-0 mb-1 mb-lg-0">
			<tile-vidget v-if="station !== undefined"
				title="Напруга в мережі живлення"
				class="widget-7x5"
				style="margin: 0 !important;"
				:style="station.service_unit.isConnect ? '' : 'filter: grayscale(100%);'"
			>
				<div class="row m-0 mt-auto p-0">
					<div class="col mx-0 ps-2 text-center metric-value-text">
						<span class="fs-1">
							{{ station.getFormatedMetric(ServiceUnit.metricKeys.u220, 'service') == ''
								? '-'
								: `${station.getFormatedMetric(ServiceUnit.metricKeys.u220, 'service', 0)}\xa0В`
							}}
						</span>
					</div>
				</div>
				<div class="row m-0 mb-3 p-0 mt-auto">
				</div>
			</tile-vidget>
		</div>
		<div class="col-md-6 col-lg-3 m-0 mb-1 mb-lg-0">
			<tile-vidget v-if="station !== undefined"
				title="Вихідна потужність"
				class="widget-7x5"
				style="margin: 0 !important;"
				:style="station.power_unit.isConnect ? '' : 'filter: grayscale(100%);'"
			>
				<div class="row m-0 mt-auto p-0">
					<div class="col mx-0 ps-2 text-center metric-value-text">
						<span class="fs-1 font-monospace text-nowra">
							{{ outPowerPromt }}
						</span>
					</div>
				</div>
				<div class="row m-0 mb-3 p-0 mt-auto">
				</div>
			</tile-vidget>
		</div>
		<div class="col-md-6 col-lg-3 m-0 mb-1 mb-lg-0">
			<tile-vidget v-if="station !== undefined"
				title="Опір кола поляризації"
				class="widget-7x5"
				style="margin: 0 !important;"
				:style="station.power_unit.isConnect ? '' : 'filter: grayscale(100%);'"
			>
				<div class="row m-0 mt-auto p-0">
					<div class="col mx-0 ps-2 text-center metric-value-text">
						<span class="fs-1 font-monospace text-nowra">
							{{ resistancePolarizationCirclePromt  }}
						</span>
					</div>
				</div>
				<div class="row m-0 mb-3 p-0 mt-auto">
				</div>
			</tile-vidget>
		</div>
		<div class="col-md-6 col-lg-3 m-0 mb-1 mb-lg-0">
			<tile-vidget
				title="Значення потенціалу при вимкненному УКЗ"
				class="widget-7x5"
				style="margin: 0 !important;"
				:activityLabel="true"
				@dblclick="showMeasurePotentialOnOffStationForm = true"
			>
				<div class="row m-0 p-0 mt-auto">
					<div class="col-6 mx-0 ps-2 text-start metric-name-text">
						Eavg
					</div>
					<div class="col-6 mx-0 pe-2 text-end metric-value-text">
						{{ station.getFormatedMetric('off_station_potential_avg', 'service', 2) }}
					</div>
				</div>
				
				<div class="row m-0 mb-2 p-0 mt-auto">
					<div class="col-1 mx-0 ps-2 pe-1 text-start metric-name-text">
						Час
					</div>
					<div class="col-11 mx-0 pe-2 ps-1 text-end">
						{{ stationMetricTime('off_station_potential_avg', 'service') }}
					</div>
				</div>
			</tile-vidget>
		</div>
	</div>

	<div class="row col-xxl p-0 m-0 g-1">
		<div class="col-12 m-0 mb-1 mb-xxl-0">
			<half-line-vidget
				name="Температура в шафі СКЗ"
				:value="
					station.getFormatedMetric(ServiceUnit.metricKeys.tOutdoor, 'service') === undefined
						? '-'
						: station.getFormatedMetric(ServiceUnit.metricKeys.tOutdoor, 'service', 1)
				"
				unit="°C"
				:style="station.service_unit.isConnect ? '' : 'filter: grayscale(100%);'"
			/>
		</div>
		<div class="col-12 m-0 mb-1 mb-xxl-0">
			<half-line-vidget
				name="Температура силового блока"
				:value="
					station.getFormatedMetric(PowerUnit.metricKeys.transistorsTemperature, 'power')
						? station.getFormatedMetric(PowerUnit.metricKeys.transistorsTemperature, 'power', 1)
						: '-'
				"
				:unit="station.getFormatedMetric(PowerUnit.metricKeys.transistorsTemperature, 'power') ? '°C' : ''"
				:style="station.power_unit.isConnect ? '' : 'filter: grayscale(100%);'"
			/>
		</div>
		<div class="col-12 m-0 mb-1 mb-xxl-0">
			<half-line-vidget
				name="Час захисту споруди"
				:value="protectTime"
				:style="station.power_unit.isConnect ? '' : 'filter: grayscale(100%);'"
			/>
		</div>
		<div class="col-12 m-0 mb-1 mb-xxl-0">
			<half-line-vidget
				name="Загальний час напрацювання"
				:value="operationTime"
				:style="station.power_unit.isConnect ? '' : 'filter: grayscale(100%);'"
			/>
		</div>
		<div class="col-12 m-0 mb-1 mb-xxl-0">
			<half-line-vidget
				name="Напруга АКБ"
				:value="akkumulatorVoltagePromt"
				:style="station.service_unit.isConnect ? '' : 'filter: grayscale(100%);'"
			/>
		</div>
	</div>
</div>

<div class="row m-0 p-0">
	<div class="row col-xxl p-0 m-0 mb-lg-1 g-1">
		<div
			v-if="station.breaker.getMetricValue(station.breaker.metricKeys.fBreakerActive)"
			class="col-md-12 col-lg-6 m-0 mb-1 mb-lg-0"
		>
			<tile-vidget
				v-if="station !== undefined"
				title="Станція в переривчатому режимі"
			>
				<div class="row m-0 my-auto p-0">
					<div class="col-6 mx-0 ps-2 text-start metric-name-text">
						<span class="">Час активації</span>
					</div>
					<div class="col-6 mx-0 pe-2 text-end metric-value-text">
						{{ station.specificMetrics['fBreakerActiveLast'] ? dateTimeToString(station.specificMetrics['fBreakerActiveLast'], false) : '-' }}
					</div>
				</div>
				<div class="row m-0 p-0 mt-auto">
					<div class="col-7 mx-0 ps-2 text-start text-nowrap metric-name-text">
						Правильність даних з GPS супутників
					</div>
					<div class="col-5 mx-0 pe-2 text-end metric-value-text">
						{{ Station.flagText(station.breaker.getMetricValue(station.breaker.metricKeys.fGpsDataOk)) }}
					</div>
				</div>
				<div class="row m-0 p-0 mt-auto mb-2">
					<div class="col-6 mx-0 ps-2 text-center text-nowrap metric-name-text">
						подача {{ station.breaker.getMetricValue(station.breaker.metricKeys.currentOnDurationFact) }} c
					</div>
					<div class="col-6 mx-0 pe-2 text-center text-nowrap metric-name-text">
						переривання {{ station.breaker.getMetricValue(station.breaker.metricKeys.currentOffDurationFact) }} c
					</div>
				</div>
			</tile-vidget>
		</div>
		<div v-else class="col-md-12 col-lg-6 m-0 mb-1 mb-lg-0">
			<tile-vidget
				v-if="station !== undefined"
				title="Задане значення стабілізації"
				class="widget-7x5"
				style="margin: 0 !important;"
				:activityLabel="true"
				@dblclick="showSetStabilizationForm = true"
			>
				<div class="row m-0 my-auto p-0">
					<div class="col-6 mx-0 ps-2 text-start metric-name-text">
						<span class="">{{ stationStabilization[Station.passportKeys.stabilization.parameter] }}</span>
					</div>
					<div class="col-6 mx-0 pe-2 text-end metric-value-text">
						{{ stationStabilization[Station.passportKeys.stabilization.value] }}
					</div>
				</div>
				<div class="row m-0 p-0 mt-auto">
					<div class="col-1 col-auto mx-0 px-0 ps-2 text-nowrap text-start">
						Задав
					</div>
					<div class="col-11 mx-0 px-0 pe-2 text-wrap text-break text-end metric-value-text">
						{{ stationStabilization[Station.passportKeys.stabilization.actor].name }}
					</div>
				</div>
				<div class="row m-0 p-0">
					<div class="col-1 mx-0 ps-2 pe-1 text-start">
						Час
					</div>
					<div class="col-11 mx-0 pe-2 ps-1 text-end">
						{{ stationStabilization[Station.passportKeys.stabilization.updateTime] }}
					</div>
				</div>
			</tile-vidget>
		</div>
		<div class="col-md-12 col-lg-6 m-0 mb-1 mb-lg-0">
			<tile-vidget
				v-if="station !== undefined"
				title="Стан зв'язку"
				class="widget-7x5"
				style="margin: 0 !important;"
			>
				<div class="row m-0 p-0">
					<div 
						v-if="station.modem_unit.isConnect"
						class="col-6 mx-0 ps-2 text-start metric-name-text"
					>
						Якість
					</div>
					<div
						v-if="station.modem_unit.isConnect"
						class="col-6 mx-0 my-0 pe-2 text-end"
					>
						{{ fixNumberPrecision(station.modem_unit.connectionQuality, 0) }}%
					</div>
				</div>
				<div class="row m-0 p-0">
					<div class="col-8 mx-0 ps-2 pe-0 text-start metric-name-text">
						<unit-icon
							unitType="modem"
							:color="connectionColor(station.modem_unit.isConnect)"
							edgeSize="18"
						/>
						Модем
					</div>
					<div class="col-4 mx-0 my-0 ps-0 pe-2 text-end">
						<span
							class="metric-value-text m-0 p-0"
							:class="{'conn-ok': station.modem_unit.isConnect,
								'conn-err': !station.modem_unit.isConnect}"
						>
							{{ station.modem_unit.connectionText.toUpperCase() }}
						</span>
					</div>
					<div class="col-12 mt-0 ps-2 text-end">
						<p v-if="!station.modem_unit.isConnect"
							class="mb-1 text-nowrap lh-sm fw-lighter" style="font-size: 0.7rem;"
						>
							з {{ station.getFormatedMetric(ModemUnit.metricKeys.lastConnection, 'modem') == ''
								? 'невідомо'
								: station.getFormatedMetric(ModemUnit.metricKeys.lastConnection, 'modem').toLocaleString()
							}}
							({{ timeDiffString(station.getFormatedMetric(ModemUnit.metricKeys.lastConnection, 'modem')) }})
						</p>
					</div>
				</div>
				<div class="row m-0 p-0">
					<div class="col-8 mx-0 ps-2 pe-0 text-start metric-name-text">
						<unit-icon
							unitType="power"
							:color="connectionColor(station.power_unit.isConnect)"
							edgeSize="18"
						/>
						Силовий
					</div>
					<div class="col-4 mx-0 my-0 ps-0 pe-2 text-end">
						<span
							class="metric-value-text m-0 p-0"
							:class="{'conn-ok': station.power_unit.isConnect,
								'conn-err': !station.power_unit.isConnect}"
						>
							{{ station.power_unit.connectionText.toUpperCase() }}
						</span>
					</div>
					<div class="col-12 mt-0 ps-2 text-end">
						<p v-if="!station.power_unit.isConnect"
							class="mb-1 text-nowrap lh-sm fw-lighter" style="font-size: 0.7rem;"
						>
							з {{ station.getFormatedMetric(PowerUnit.metricKeys.lastConnection, 'power') == ''
								? 'невідомо'
								: station.getFormatedMetric(PowerUnit.metricKeys.lastConnection, 'power').toLocaleString()
							}}
							({{ timeDiffString(station.getFormatedMetric(PowerUnit.metricKeys.lastConnection, 'power')) }})
						</p>
						<!-- <p class="m-0" v-else>&nbsp;</p> -->
					</div>
				</div>
				<!-- <div class="row my-auto">&nbsp;</div> -->
				<div class="row m-0 p-0">
					<div class="col-8 mx-0 ps-2 pe-0 text-start metric-name-text">
						<unit-icon
							unitType="service"
							:color="connectionColor(station.service_unit.isConnect)"
							edgeSize="18"
						/>
						Сервісний
					</div>
					<div class="col-4 mx-0 ps-0 pe-2 text-end">
						<span class="metric-value-text"
							:class="{
								'conn-ok': station.service_unit.isConnect,
								'conn-err': !station.service_unit.isConnect
							}"
						>
							{{ station.service_unit.connectionText.toUpperCase() }}
						</span>
					</div>
					<div class="col-12 mt-0 ps-2 text-end">
						<p v-if="!station.service_unit.isConnect"
							class="mb-1 text-nowrap lh-sm fw-lighter" style="font-size: 0.7rem;"
						>
							з {{ station.getFormatedMetric(ServiceUnit.metricKeys.lastConnection, 'service') == ''
								? 'невідомо'
								: station.getFormatedMetric(ServiceUnit.metricKeys.lastConnection, 'service').toLocaleString()
							}}
							({{ timeDiffString(station.getFormatedMetric(ServiceUnit.metricKeys.lastConnection, 'service')) }})
						</p>
						<!-- <p class="m-0" v-else>&nbsp;</p> -->
					</div>
				</div>
			</tile-vidget>
		</div>
	</div>

	<div class="row col-xxl p-0 m-0 mb-lg-1 g-1">
		<div class="col-12 m-0 mb-1 mb-lg-0">
			<tile-vidget
				v-if="station !== undefined"
				title="Стан станції"
				class="scroll-container overflow-x-hidden overflow-y-scroll widget-7x5"
				style="margin: 0 !important;"
			>
				<div class="row m-0 p-0 pb-1 px-1" v-for="(alert, index) in activeAlerts" :key="index">
					<div class="col-6 mx-0 ps-2 text-start metric-name-text">{{ alert.promt }}</div>
					<div class="col-6 mx-0 pe-2 text-end metric-value-text">{{ alert.time }}</div>
				</div>
			</tile-vidget>
		</div>
	</div>
</div>

<div class="row m-0 p-0 g-1">
	<div class="col-12 col-xl order-2 order-xl-first m-0">
		<div
			class="half-transparent-border full-width-widget m-0 p-0"
			:style="{
				height: chartHeight + 'px',
				width: !['xl', 'xxl'].includes(breakpoint) ? 'calc(100% - 3px)' : 'calc(100% - 1px)',
			}"
		>
			<station-voltage-curent-potential-chart
				:stationId="stationId"
				:time-from="iueChartTimeFrom"
				:time-to="iueChartTimeTo"
				legend-position="top"
				:is-data-zoom="isDataZoom"
				:isExpandable="true"
				:is-expand="false"
				:is-title="false"
				@expand="$router.push({
					name: 'station_chart',
					params: { stationId },
					query: $route.query,
				})"
				@loading="(v) => isChartLoading = v"
			/>
		</div>
	</div>

	<div
		class="col-12 order-1 order-xl-last m-0 p-0"
		:class="{
			'period-vidget-vertical': ['xl', 'xxl'].includes(breakpoint),
			'mb-1': !['xl', 'xxl'].includes(breakpoint),
		}"
	>
		<!-- Graph period choose -->
		<pick-period-vidget
			:defaultTileIndex="urlParamCheckedPeriodIndex ? urlParamCheckedPeriodIndex : 0"
			:forward-backward-arrows="true"
			:layout="['xl', 'xxl'].includes(breakpoint) ? 'vertical' : 'horizontal'"
			:disabled="isChartLoading"
			@period="(timeFrom, timeTo, tileIndex) => {
				setUrlParms({
					time_from: timeFrom?.toISOString(),
					time_to: timeTo?.toISOString(),
					checked_period_index: tileIndex,
				})
			}"
		/>
	</div>
</div>

<pop-up-modal
	v-model:show="showSetStabilizationForm"
	size="modal-md"
	title="Управління УКЗ"
	@reject="clearStabilizationForm()"
>
	<template v-slot:body>
		<set-stabilization-form
			:station-id="station.id"
			:is-enabled="accountStore.permissions.includes('dispatch_stations')"
			:show-title="false"
			:with-pop-up="false"
			@clear="(event) => { clearStabilizationForm = event; }"
			@request-result="showSetStabilizationForm = false"
		/>
	</template>
</pop-up-modal>

<pop-up-modal
	v-model:show="showStartStopForm"
	size="modal-md"
	title="Запуск / зупинка силового модуля станції"
	@reject="showStartStopForm = false"
>
	<template v-slot:body>
		<start-stop-form
			:station-id="station.id"
			:is-enabled="accountStore.permissions.includes('dispatch_stations')"
			:in-modal="true"
			@request-result="showStartStopForm = false"
		/>
	</template>
</pop-up-modal>

<pop-up-modal
	v-model:show="showMeasurePotentialOnOffStationForm"
	v-model:show-description="showMeasurePotentialOnOffStationFormDescription"
	size="modal-md"
	title="Запит вимірювання потенціалу на вимкненній СКЗ"
	@reject="showMeasurePotentialOnOffStationForm = false"
>
	<template v-slot:body>
		<measure-potential-on-off-station-form
			:station-id="station.id"
			:is-enabled="accountStore.permissions.includes('dispatch_stations')"
			:in-modal="true"
			:show-description="showMeasurePotentialOnOffStationFormDescription"
			@request-result="showMeasurePotentialOnOffStationForm = false"
		/>
	</template>
</pop-up-modal>

<pop-up-modal
	v-model:show="showPerformStationSurveyForm"
	v-model:show-description="showPerformStationSurveyFormDescription"
	size="modal-md"
	title="Запит опитування станції"
	@reject="showPerformStationSurveyForm = false"
>
	<template v-slot:body>
		<perform-survey-form
			:station-id="station.id"
			:is-enabled="accountStore.permissions.includes('dispatch_stations')"
			:show-electric-meter="false"
			:in-modal="true"
			:show-description="showPerformStationSurveyFormDescription"
			@request-result="showPerformStationSurveyForm = false"
		/>
	</template>
</pop-up-modal>

<pop-up-modal
	v-model:show="showPerformElectricMeterSurveyForm"
	size="modal-md"
	title="Запит опитування електролічильника"
	@reject="showPerformElectricMeterSurveyForm = false"
>
	<template v-slot:body>
		<perform-survey-form
			:station-id="station.id"
			:is-enabled="accountStore.permissions.includes('dispatch_stations')"
			:show-station="false"
			:in-modal="true"
			@request-result="showPerformElectricMeterSurveyForm = false"
		/>
	</template>
</pop-up-modal>

<pop-up-modal
	v-model:show="showLightningsTable"
	size="modal-lg"
	:title="`Таблиця блискавок поруч зі станцією за останні ${lightningsSearchDepthDays} днів`"
	@reject="showLightningsTable = false"
>
	<template v-slot:body>
		<lightnings-table
			:time-from="fromTime"
			:time-to="toTime"
			:station-ids="[stationId, ]"
			:in-modal="true"
		/>
	</template>
</pop-up-modal>
</template>




<script>
import HalfLineVidget from "@/components/Vidgets/HalfLineVidget.vue"
import TileVidget from "@/components/Vidgets/TileVidget.vue"
import UprotectChart from '@/components/Charts/UprotectChart.vue'
import IoutChart from '@/components/Charts/IoutChart.vue'
import UoutChart from '@/components/Charts/UoutChart.vue'
import StationVoltageCurentPotentialChart from '@/components/Charts/StationVoltageCurentPotentialChart.vue'
import PickPeriodVidget from '@/components/Vidgets/PickPeriodVidget.vue'
import SetStabilizationForm from './SetStabilizationForm.vue'
import StartStopForm from "./StartStopForm.vue"
import MeasurePotentialOnOffStationForm from "./MeasurePotentialOnOffStationForm.vue"
import PerformSurveyForm from './PerformSurveyForm.vue'
import LightningsTable from "@/components/LightningsTable.vue"
import PopUpModal from "@/components/PopUpModal.vue"
import UnitIcon from '@/components/Icons/UnitIcon.vue'
import { useSizeBreakpoint } from '@/composables/size-breakpoint.js'
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { useStationsHistoryStore } from '@/stores/StationsHistoryStore.js'
import {
	eventSchema,
	isLightningAboveStaion,
	flashDistance,
	useEvents,
} from '@/composables/events.js'
import { Station } from '@/models/station.js'
import { Breaker } from "@/models/breaker.js"
import { PowerUnit } from '@/models/powerUnit.js'
import { ServiceUnit } from '@/models/serviceUnit.js'
import { ModemUnit } from '@/models/modemUnit.js'
import { ElectricMeter } from "@/models/electricMeter.js"
import {
	subtractHoursFromNowDate,
	fixNumberPrecision,
	timeDiffString,
	connectionColor,
	timeFromNowPromt,
	capitalizeFirstLetter,
	dateTimeToString,
	verboseTimePeriod,
	subtractDaysFromNowDate,
	dayStart,
	dayEnd,
} from '@/helpers.js'
import { STAB_PARMS } from '@/app.conf.js'
import { parseTimeDate, INFLUXDB, readStationMetric } from '@/api/api.js'



export default {
	inject: ['headerHeight'],

	METRICS_UPDATE_RATE: 60000,
	
	components: {
		HalfLineVidget,
		TileVidget,
		PickPeriodVidget,
		UprotectChart,
		IoutChart,
		UoutChart,
		StationVoltageCurentPotentialChart,
		SetStabilizationForm,
		MeasurePotentialOnOffStationForm,
		PerformSurveyForm,
		LightningsTable,
		StartStopForm,
		PopUpModal,
		UnitIcon,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	setup(props) {
		const { breakpoint } = useSizeBreakpoint()
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()
		const historyStore = useStationsHistoryStore()

		const { allEvents: lightningEvents, setFilters } = useEvents()
		const lightningsSearchDepthDays = 30
		const fromTime = dayStart(subtractDaysFromNowDate(lightningsSearchDepthDays))
		const toTime = dayEnd(new Date())
		setFilters({
			fromTime: fromTime,
			toTime: toTime,
			eventTypes: [eventSchema.eventType.allowed.lightning.key, ],
			stationIds: [props.stationId, ],
		})
		

		return {
			breakpoint,
			Station,
			PowerUnit,
			ServiceUnit,
			ModemUnit,
			ElectricMeter,
			accountStore,
			stationsStore,
			historyStore,

			eventSchema,
			lightningsSearchDepthDays,
			isLightningAboveStaion,
			flashDistance,
			fromTime,
			toTime,
			lightningEvents,


			fixNumberPrecision,
			timeDiffString,
			dateTimeToString,
			subtractHoursFromNowDate,
			connectionColor,
		}
	},

	data() {
		return {
			//
			protectPercent: "-",
			operationPercent: "-",

			// Update IUE chart time to
			isChartLoading: true,

			// Specific for this view metrics update timer
			updateMetricsInterval: null,

			// Station manage forms show flags
			showSetStabilizationForm: false,
			showStartStopForm: false,

			showMeasurePotentialOnOffStationForm: false,
			showMeasurePotentialOnOffStationFormDescription: false,

			showPerformStationSurveyForm: false,
			showPerformStationSurveyFormDescription: false,

			showPerformElectricMeterSurveyForm: false,
			//
			clearStabilizationForm: () => {},

			// Lightnings
			showLightningsTable: false,
		}
	},

	beforeCreate() {
	},

	created() {
		const urlParms = {}
		
		// If no url parameter time_from and checked tile
		if (this.urlParamTimeFrom == undefined
			&& this.urlParamCheckedPeriodIndex == undefined
		) {
			//this.setUrlParms({ checked_period_index: 0, })
			urlParms.checked_period_index = 0
		}

		// If no url parameter time_from
		if (this.urlParamTimeFrom == undefined) {
			//this.setTimeFrom(new Date((new Date()).getTime() - (24 * 3600 * 1000)))
			urlParms.time_from = new Date((new Date()).getTime() - (24 * 3600 * 1000)).toISOString()
		}

		// If no url parameter time_to
		if (this.urlParamTimeTo == undefined) {
			urlParms.time_to = new Date().toISOString()
		}

		this.setUrlParms(urlParms)

		if (this.urlParamTimeTo == undefined) {
			this.setUrlParms({ time_to: new Date().toISOString() })
		}

		// Read station metrics
		this.fetchTimePeriodMetrics()
		// Updates every * seconds
		this.updateMetricsInterval = setInterval(async () => {
			this.fetchTimePeriodMetrics()
		}, this.$options.METRICS_UPDATE_RATE);
	},

	mounted() {},

	watch: {},

	methods: {
		stationMetricTime(metricName, unit="any") {
			let metric = this.station?.getMetric(metricName, unit)
			
			if (typeof metric == 'object') {
				return metric.time.toLocaleString()
			} else {
				return '-'
			}

		},

		// Return text promt from boolean metric
		stationMetricFlagText(metricName, reverse=false) {
			let metric = this.station.getFormatedMetric(metricName)
			return Station.flagText(metric, reverse)
		},

		// Fetching protect time and operation time metrics for period from passport.
		// Calculate percents and save to component data.
		fetchTimePeriodMetrics() {
			if (!this.station.passport?.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.operaionAndProtectionStartDate]) {
				this.protectPercent = "-"
				return
			}

			// Fetch time protect
			let timeProtectArr = []
			readStationMetric(
				this.metricsId,
				INFLUXDB.station_metrics.power_unit, 
				PowerUnit.metricKeys.protectionTime,
				timeProtectArr,
				parseTimeDate(this.station.passport?.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.operaionAndProtectionStartDate], true),
				'now',
				20000,
			).then(result => {
				// console.log("Fetch time protect: ", result, timeProtectArr)
				if (!result) {
					this.protectPercent = "-"
					return
				}

				const values = timeProtectArr.map((el) => el[PowerUnit.metricKeys.protectionTime] )

				if (values.length < 2) {
					this.protectPercent = "-"
					return
				}

				// Calculate persent
				const calendarRange = (new Date().getTime()
					- parseTimeDate(this.station.passport?.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.operaionAndProtectionStartDate], true).getTime())
					/ (1000 * 60 * 60)
				const protectRange = values[values.length - 1] - values[0]
				if (protectRange < 0) {
					this.protectPercent = "-"
				} else {
					this.protectPercent = protectRange / calendarRange * 100
					this.protectPercent = this.protectPercent.toFixed(0)
					if (this.protectPercent > 100) {
						this.protectPercent = 100
					}
				}
			}).catch(err => {
				console.error("Error on read stations metric: ", err, ".")
			})
			
			// Fetch operation time
			let timeOperationArr = []
			readStationMetric(
				this.metricsId,
				INFLUXDB.station_metrics.power_unit, 
				PowerUnit.metricKeys.operationTime,
				timeOperationArr,
				parseTimeDate(this.station.passport?.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.operaionAndProtectionStartDate], true),
				'now',
				20000,
			).then(result => {
				//console.log("Fetch time protect: ", result, metricArr)
				if (!result) {
					this.operationPercent = "-"
					return
				}

				const values = timeOperationArr.map((el) => el[PowerUnit.metricKeys.operationTime] )

				if (timeOperationArr.length < 2) {
					this.operationPercent = "-"
					return
				}

				// Calculate persent
				const calendarRange = (new Date().getTime()
					- parseTimeDate(this.station.passport?.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.operaionAndProtectionStartDate], true).getTime())
					/ (1000 * 60 * 60)
				const operationRange = values[values.length - 1] - values[0]
				if (operationRange < 0) {
					this.operationPercent = "-"
				} else {
					this.operationPercent = operationRange / calendarRange * 100
					this.operationPercent = this.operationPercent.toFixed(0)
					if (this.operationPercent > 100) {
						this.operationPercent = 100
					}
				}
			}).catch(err => {
				console.error("Error on read stations metric: ", err, ".")
			})
		},

		setUrlParms(parms) {
			const query = { ...this.$route.query }

			this.$router.replace({
				name: this.$route.name,
				params: this.$route.params,
				query: Object.assign(query, parms),
			}).catch(err => {
				console.error("Error on replace route: ", err, ".")
			})
		},
	},

	computed: {
		station() { return this.stationsStore.station(this.stationId) },

		metricsId() { return this.station.passport.get(Station.passportKeys.metricsId) },

		stabilizationModePromt() {
			return PowerUnit.stabilizationModeText(
				this.station?.getMetric(PowerUnit.metricKeys.stationStabilizationMode, 'power')?.value,
				{
					[PowerUnit.metricKeys.stationStabilizationPotential]: this.station?.getMetric(PowerUnit.metricKeys.stationStabilizationPotential, 'power')?.value,
					[PowerUnit.metricKeys.stationStabilizationVoltage]: this.station?.getMetric(PowerUnit.metricKeys.stationStabilizationVoltage, 'power')?.value,
					[PowerUnit.metricKeys.stationStabilizationCurent]: this.station?.getMetric(PowerUnit.metricKeys.stationStabilizationCurent, 'power')?.value,

				},
				this.station?.passport.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.unitVersion]
			)
		},

		akkumulatorVoltagePromt() {
			let serviceUnitVersion = this.station.passport.get(Station.passportKeys.serviceUnit.self)
			serviceUnitVersion = serviceUnitVersion[Station.passportKeys.serviceUnit.unitVersion]

			let promt =
				this.station.getFormatedMetric(ServiceUnit.metricKeys.uAkk, 'service') === undefined
				? '-'
				: `${this.station.getFormatedMetric(ServiceUnit.metricKeys.uAkk, 'service', 1)} В`

			// Add charge as a percentage if service unit version is 2024 or 2025
			if (serviceUnitVersion == ServiceUnit.versions['2024-1']
				|| serviceUnitVersion == ServiceUnit.versions['2024-2']
				|| serviceUnitVersion == ServiceUnit.versions['2025-1']
				|| serviceUnitVersion == ServiceUnit.versions['2025-2']
				|| serviceUnitVersion == ServiceUnit.versions['2025-3']
			) {
				promt += this.station.getFormatedMetric('AkkCharge', 'service') === undefined
					? ''
					: ` (${this.station.getFormatedMetric('AkkCharge', 'service')}%)`
			}

			return promt
		},

		// Calculate power counter value, or return "-" if can't
		electricMeterValue() {
			let unit = "кВт⋅год"
			let value = '-'

			// Meter type is impulse imput of service unit
			if (this._electricMeterType == ElectricMeter.versions.impulseInput) {
				const metric = this.station.getFormatedMetric(
					ServiceUnit.metricKeys.extPwrCounterEnergy,
					"service"
				)
				
				if (metric) {
					value = Number(metric).toFixed(2)
				} else {
					return ["-",""]
				}
			// Meter type is nik dlms or gama100
			} else if (this.station?.electricMeterIsSeparateUnit) {
				value = this.station.electricMeter.getMetricValue(
					ElectricMeter.metricKeys.fullActiveEnergy, 2
				)
			} else if (this._electricMeterType == ElectricMeter.versions.unknown) {
				return ["-",""]
			} else {
				return ["-",""]
			}

			return [value, unit]
		},

		electricMeterConnection() {
			// Meter type is impulse imput of service unit
			if (this._electricMeterType == ElectricMeter.versions.impulseInput) {
				return this.station.service_unit.isConnect
			// Meter type is nik dlms or gama100
			} else if (this.station?.electricMeterIsSeparateUnit) {
				return this.station.electricMeter.isConnect
			} else if (this._electricMeterType == ElectricMeter.versions.unknown) {
				return true
			} else {
				return false
			}
		},

		_electricMeterType() {
			// If meter type is undefine
			if (!this.station.passport.has(Station.passportKeys.electricMeter.self)
				|| this.station.passport.get(Station.passportKeys.electricMeter.self)[Station.passportKeys.electricMeter.type] == undefined) {
				return undefined
			}

			return this.station.passport.get(Station.passportKeys.electricMeter.self)[Station.passportKeys.electricMeter.type]
		},

		// Power module output power calculation
		outPowerPromt() {
			const uOut = this.station.getFormatedMetric('Uout', 'power')
			const iOut = this.station.getFormatedMetric('Iout', 'power')

			if (iOut == '' || iOut == '') {
				return '-'
			}

			const pwr = uOut * iOut
			
			if (pwr >= 1000) {
				return `${(pwr / 1000.0).toFixed(1)}\xa0КВт`
			} else {
				return `${pwr.toFixed(0)}\xa0Вт`
			} 
		},

		stationStabilization() {
			// Prepare default values
			const stab = new Object()
			stab[Station.passportKeys.stabilization.parameter] = '-'
			stab[Station.passportKeys.stabilization.value] = '-'
			stab[Station.passportKeys.stabilization.actor] = { name: '-' }
			stab[Station.passportKeys.stabilization.updateTime] = '-'
			
			if (!this.station.passport.has(Station.passportKeys.stabilization.self)) {
				return stab
			}

			const stabilization = this.station.passport.get(Station.passportKeys.stabilization.self)

			const stabParm = Object.values(STAB_PARMS)
				.find((el) => el.id == stabilization[Station.passportKeys.stabilization.parameter])
			stab[Station.passportKeys.stabilization.parameter] = stabParm.name
				? capitalizeFirstLetter(stabParm.name)
				: stabilization[Station.passportKeys.stabilization.parameter]

			stab[Station.passportKeys.stabilization.value] =
				stabilization[Station.passportKeys.stabilization.value] + ' ' + stabParm.unit
			
			stab[Station.passportKeys.stabilization.actor].name = 
				stabilization[Station.passportKeys.stabilization.actor].name

			stab[Station.passportKeys.stabilization.updateTime] =
				parseTimeDate(stabilization[Station.passportKeys.stabilization.updateTime]).toLocaleString()

			return stab
		},

		resistancePolarizationCirclePromt() {
			const uOut = this.station.getFormatedMetric('Uout', 'power')
			const iOut = this.station.getFormatedMetric('Iout', 'power')

			if (iOut == '' || iOut == '') {
				return '-'
			}

			const r = uOut / iOut
			
			if (r < 1.0) {
				//return `${(r * 1000.0).toFixed(0)}\xa0мОм`
				return `${r.toFixed(2)}\xa0Ом`
			} else {
				return `${r.toFixed(0)}\xa0Ом`
			} 
		},

		_timePeriodPromt() {
			let periodPromt = "-"
			if (this.station.passport.has(Station.passportKeys.powerUnit.self)
				&& this.station.passport?.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.operaionAndProtectionStartDate]
			) {
				const startDate = parseTimeDate(
					this.station.passport?.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.operaionAndProtectionStartDate],
					true
				)
				//console.log("Start Date", this.station.passport?.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.operaionAndProtectionStartDate], startDate.toString())
				periodPromt = `${String(startDate.getDate()).padStart(2, '0')}.${String(startDate.getMonth()+1).padStart(2, '0')}.${String(startDate.getFullYear()).slice(2)}`
			}
			return periodPromt
		},

		protectTime() {
			let metric = this.station?.getMetric(PowerUnit.metricKeys.protectionTime, 'power')

			if (metric === undefined) {
				return '-'
			}
			//console.log("protectionTime metric", metric)

			const valueFromStartDate_s = metric.value >= metric?.meta?.start_value ? (metric.value - metric.meta.start_value) * 60 * 60 : 0

			return `${verboseTimePeriod(valueFromStartDate_s.toFixed(0), true)} (${this.protectPercent}%) з ${this._timePeriodPromt}`
		},

		operationTime() {
			let metric = this.station?.getMetric(PowerUnit.metricKeys.operationTime, 'power')

			if (metric === undefined) {
				return '-'
			}
			// console.log("operationTime metric", metric)

			const valueFromStartDate_s = metric.value >= metric?.meta?.start_value ? (metric.value - metric.meta.start_value) * 60 * 60 : 0

			return `${verboseTimePeriod(valueFromStartDate_s.toFixed(0), true)} (${this.operationPercent}%) з ${this._timePeriodPromt}`
		},

		uProtect() {
			switch(this.station.uProtectSource) {
				case null:
					return undefined
				case 'power': {
					const metric = this.station?.getMetric(PowerUnit.metricKeys.eOut, 'power')
					return typeof metric == 'object' ? metric.value.toFixed(2) : undefined
				}
				case 'service': {
					const metric = this.station?.getMetric(ServiceUnit.metricKeys.eAvg, 'service')
					return typeof metric == 'object' ? metric.value.toFixed(2) : undefined
				}
				default:
					return undefined
			}
		},

		iueChartTimeFrom() {
			return this.urlParamTimeFrom
		},

		iueChartTimeTo() {
			return this.urlParamTimeTo
		},

		isDataZoom() {
			//console.log('data zoom = ', this.urlParamIsDataZoom, this.urlParamIsDataZoom == 'false')
			if (this.urlParamIsDataZoom == 'false') {
				return false
			} else {
				return true
			}
		},

		urlParamTimeFrom() {
			//console.log('timeFrom in URL', this.$route.query)
			if (this.$route.query?.time_from) {
				return new Date(this.$route.query.time_from)
			} else {
				return undefined
			}
		},

		urlParamTimeTo() {
			if (this.$route.query?.time_to) {
				return  new Date(this.$route.query?.time_to)
			} else {
				return undefined
			}
		},

		urlParamCheckedPeriodIndex() {
			return this.$route.query.checked_period_index
				? Number(this.$route.query.checked_period_index)
				: undefined
		},

		urlParamIsDataZoom() {
			return this.$route.query.is_data_zoom
		},

		boxDoorStatePromt() {
			const stateCode = this.station.getMetric(ServiceUnit.metricKeys.fSecurityCircuitBoxDoor, 'service')?.value
			let promt = ServiceUnit.boxDoorStatePromt(stateCode)

			switch(stateCode) {
				case  ServiceUnit.boxDoorStateCodes.open:
					promt += this.station.specificMetrics.boxDoorLastCloseTime
						? '\xa0' + timeFromNowPromt(this.station.specificMetrics.boxDoorLastCloseTime)
						: ''
					break
				case  ServiceUnit.boxDoorStateCodes.close:
					promt += this.station.specificMetrics.boxDoorLastOpenTime
						? '\xa0' + timeFromNowPromt(this.station.specificMetrics.boxDoorLastOpenTime)
						: ''
					break
				case ServiceUnit.boxDoorStateCodes.short:
					break
				default:
					promt = '-'
			}

			return promt
		},

		activeAlerts() {
			const activeAlerts = []

			// Power unit alerts
			PowerUnit.alertKeys.forEach(key => {
				if (this.station.getFormatedMetric(key, 'power')) {
					activeAlerts.push({
						promt: capitalizeFirstLetter(PowerUnit.alertPromt(key)),
						time: this.stationMetricTime(key, 'power')
					})
				}
			})

			// Service unit alerts
			this.station.service_unit.activeSecurityCircuits.forEach(circuit => {
				const key = 'f_security_circuit_' + circuit
				let alert = {
					promt: '',
					time: '',
				}
				
				// Circuit state
				const stateCode = this.station.getFormatedMetric(key, 'service')
				if (typeof stateCode == 'string' && stateCode.length == 0) {
					return
				}
				alert.promt = capitalizeFirstLetter(ServiceUnit.alertPromt(key,  parseInt(stateCode)))

				const circuitMetrics = this.historyStore.getMetricHistory(
					this.metricsId,
					INFLUXDB.station_metrics.service_unit,
					key,
				)

				if (circuitMetrics.length > 0) {
					let predicate = () => { return false }
					switch(stateCode) {
						case  ServiceUnit.boxDoorStateCodes.open:
							predicate = (el) => el.value == ServiceUnit.boxDoorStateCodes.close
							break
						case  ServiceUnit.boxDoorStateCodes.close:
							predicate = (el) => el.value == ServiceUnit.boxDoorStateCodes.open
							break
						case ServiceUnit.boxDoorStateCodes.short:
							predicate = (el) => el.value != ServiceUnit.boxDoorStateCodes.short
							break
						default:
							break
					}

					alert.time = circuitMetrics.findLast(predicate)?.time
					if (alert.time) {
						alert.promt += '\xa0' + timeFromNowPromt(alert.time)
						alert.time = alert.time.toLocaleString()
					}
				}
				
				activeAlerts.push(alert)
			})

			if (this.station?.breaker?.passport 
				&& this.station.breaker.passport[Breaker.passportKeys.unitVersion] !== Breaker.versions.unknown
			) {
				// Breaker alerts
				const breakerAlerts = [
					{
						metricKey: this.station.breaker.metricKeys.fEepromError,
						specificMetricKey: 'fEepromErrorLast',
						metricAlertValue: true,
					},
					{
						metricKey: this.station.breaker.metricKeys.fServiceUnitConnectionError,
						specificMetricKey: 'fServiceUnitConnectionErrorLast',
						metricAlertValue: true,
					},
					{
						metricKey: this.station.breaker.metricKeys.fPowerUnitConnectionError,
						specificMetricKey: 'fPowerUnitConnectionErrorLast',
						metricAlertValue: true,
					},
					{
						metricKey: this.station.breaker.metricKeys.fGpsDataOk,
						specificMetricKey: 'fGpsDataOkLast',
						metricAlertValue: false,
					},
				]

				for (const alert of breakerAlerts) {
					if (this.station.breaker.getMetricValue(alert.metricKey) === alert.metricAlertValue) {
						// const metric = this.station.breaker.getMetric(alert.metricKey)

						activeAlerts.push({
							promt: 'Переривач: ' + capitalizeFirstLetter(this.station.breaker.alertPromts[alert.metricKey]),
							time: this.station?.specificMetrics[alert.specificMetricKey]?.toLocaleString() ?
								this.station?.specificMetrics[alert.specificMetricKey]?.toLocaleString() :
								'-',
						})
					}
				}
			}

			return activeAlerts
		},

		lastLightningEvent() {
			return this.lightningEvents
				?.toSorted((a, b) =>
					a[eventSchema.payload.key][eventSchema.payload.allowed.flashTimeUTC.key].getTime() 
						> b[eventSchema.payload.key][eventSchema.payload.allowed.flashTimeUTC.key].getTime()
				)?.at(-1)
		},

		chartHeight() {
			const	body = document.body,
					html = document.documentElement;
			const	docHeight = Math.max(body.scrollHeight, body.offsetHeight, 
					html.clientHeight, html.scrollHeight, html.offsetHeight);
			const chartHeight = docHeight - Number(this.headerHeight.replace(/[^0-9]/gi, '')) - 150 * 4 - 10
			
			return chartHeight < 300 ? 300 : chartHeight
		},
	},

	beforeUnmount() {
		if (this.updateMetricsInterval != null) {
			clearInterval(this.updateMetricsInterval)
			this.updateMetricsInterval = null
		}
	}
}
</script>




<style src="@/assets/widget.css" scoped></style>
<style scoped>
.period-vidget-vertical {
	flex: 0 0 auto; /* Забороняє розтягуватись */
	/* min-width: 9em;
	max-width: 11em; */
	width: 10em;
}
</style>